import { changeList as changeListApi, init as initApi, update as updateApi } from "../../service/EvaluationItemService";

export const INIT_SUCCESS = "EVALUATION_ITEM_INIT_SUCCESS";
export const INIT_FAIL = "EVALUATION_ITEM_INIT_FAIL";
export const CHANGE_LIST_SUCCESS = "EVALUATION_ITEM_CHANGE_LIST_SUCCESS";
export const CHANGE_LIST_FAIL = "EVALUATION_ITEM_CHANGE_LIST_FAIL";
export const UPDATE_SUCCESS = "EVALUATION_ITEM_UPDATE_SUCCESS";
export const UPDATE_FAIL = "EVALUATION_ITEM_UPDATE_FAIL";

export const init = () => dispatch => {
  initApi().then(response => {
    if (response.message !== null) {
      dispatch({ type: INIT_FAIL });
      alert(`メッセージコード: ${response.messageCode}\r\nメッセージ：${response.message}`);
    }
    const { abolitionFlgText, abolitionFlgValue, evaluationCategory, evaluationList, evaluationItems } = response;
    const [abolitionFlgValueFalse, abolitionFlgValueTrue] = abolitionFlgValue;
    const categoryValueOptions = evaluationCategory.map(category => ({
      value: category.categoryId,
      label: category.categoryName
    }));
    const age = evaluationList[0].listId;
    const rows = evaluationItems.map((item, index) => {
      return {
        id: index,
        itemId: item.itemId,
        itemName: item.itemName,
        catagoryName: item.categoryId,
        outputOrder: item.outputOrder,
        ratingGradeE: item.stickerFileName[item.stickerId.findIndex(id => id == "06")],
        ratingGradeD: item.stickerFileName[item.stickerId.findIndex(id => id == "05")],
        ratingGradeC: item.stickerFileName[item.stickerId.findIndex(id => id == "04")],
        ratingGradeB: item.stickerFileName[item.stickerId.findIndex(id => id == "03")],
        ratingGradeA: item.stickerFileName[item.stickerId.findIndex(id => id == "02")],
        ratingGradeS: item.stickerFileName[item.stickerId.findIndex(id => id == "01")],
        abolition: item.abolitionFlg ? abolitionFlgValueTrue : abolitionFlgValueFalse,
        registeredDate: item.createdDate,
        updatedDate: item.updatedDate
      };
    });
    dispatch({
      type: INIT_SUCCESS,
      payload: {
        listId: response.evaluationList[0].listId,
        data: response,
        rows: rows,
        abolitionFlgTexts: abolitionFlgText,
        abolitionFlgValues: abolitionFlgValue,
        categoryValueOptions: categoryValueOptions,
        evaluationList: evaluationList,
        age: age
      }
    });
  });
};

export const changeList = listId => dispatch => {
  changeListApi(listId)
    .then(response => {
      if (response.message !== null) {
        dispatch({ type: CHANGE_LIST_FAIL, payload: { listId: listId, data: [] } });
        alert(`エラーコード: ${response.messageCode}\r\n メッセージ：${response.message}`);
        return;
      }
      const { abolitionFlgText, abolitionFlgValue, evaluationCategory, evaluationList, evaluationItems } = response;
      const [abolitionFlgValueFalse, abolitionFlgValueTrue] = abolitionFlgValue;
      const categoryValueOptions = evaluationCategory.map(category => ({
        value: category.categoryId,
        label: category.categoryName
      }));
      const rows = evaluationItems.map((item, index) => {
        return {
          id: index,
          itemId: item.itemId,
          itemName: item.itemName,
          catagoryName: item.categoryId,
          outputOrder: item.outputOrder,
          ratingGradeE: item.stickerFileName[item.stickerId.findIndex(id => id == "06")],
          ratingGradeD: item.stickerFileName[item.stickerId.findIndex(id => id == "05")],
          ratingGradeC: item.stickerFileName[item.stickerId.findIndex(id => id == "04")],
          ratingGradeB: item.stickerFileName[item.stickerId.findIndex(id => id == "03")],
          ratingGradeA: item.stickerFileName[item.stickerId.findIndex(id => id == "02")],
          ratingGradeS: item.stickerFileName[item.stickerId.findIndex(id => id == "01")],
          abolition: item.abolitionFlg ? abolitionFlgValueTrue : abolitionFlgValueFalse,
          registeredDate: item.createdDate,
          updatedDate: item.updatedDate
        };
      });

      dispatch({
        type: CHANGE_LIST_SUCCESS,
        payload: {
          listId: listId,
          data: response,
          rows: rows,
          abolitionFlgTexts: abolitionFlgText,
          abolitionFlgValues: abolitionFlgValue,
          categoryValueOptions: categoryValueOptions,
          evaluationList: evaluationList,
          age: listId
        }
      });
    })
    .catch(error => {
      dispatch({ type: CHANGE_LIST_FAIL, payload: { listId: listId, data: [], error: error } });
    });
};

export const update = rows => (dispatch, getState) => {
  const [abolitionFlgValueFalse, abolitionFlgValueTrue] = getState().evaluationItem.abolitionFlgValues;

  const params = rows.map(row => ({
    itemId: row.itemId,
    itemName: row.itemName,
    listId: getState().evaluationItem.age,
    categoryId: row.catagoryName,
    outputOrder: row.outputOrder,
    abolitionFlg: row.abolition === abolitionFlgValueTrue ? abolitionFlgValueTrue : abolitionFlgValueFalse,
    stickerId: ["06", "05", "04", "03", "02", "01"],
    stickerFile: [
      row.ratingGradeE,
      row.ratingGradeD,
      row.ratingGradeC,
      row.ratingGradeB,
      row.ratingGradeA,
      row.ratingGradeS
    ]
  }));
  updateApi(params)
    .then(() => {
      dispatch({ type: UPDATE_SUCCESS, payload: { data: params } });
      alert("評価項目を更新しました。");
    })
    .catch(error => {
      dispatch({ type: UPDATE_FAIL, payload: { error: error } });
    });
};
